export class Contratante {
    clienteIDEnc: string = "";
    cpId: string = '';
    tipo_persona: string = 'F';
    rfc: string = '';
    nombres: string = '';
    ap_pat: string = '';
    ap_mat: string = '';
    sexo: string = 'M';
    sexoTexto: string = '';
    edoCivil: string = 'S';
    fec_nac: string = '';
    fec_nac_str: string = '';
    noempleado: string = '';
    avatar: string = "";
    direccion: DireccionContratante = new DireccionContratante();
    moral: ContratanteMoral = new ContratanteMoral();
    telefonos: Array<TelefonosContratante> = new Array<TelefonosContratante>();
    celular: Array<TelefonosContratante> = new Array<TelefonosContratante>();
    correos: Array<CorreosContratante> = new Array<CorreosContratante>();
}

export class DireccionContratante {
    calle: string = '';
    no_ext: string = '';
    no_int: string = '';
    col: string = '';
    delegacion_mcpio: string = '';
    estado: string = '';
    cp: string = '';
    pais_mcpio: string = 'MEXICO';
    c_mcpio: string = '0';
    c_col: string = '0';
    tipoDir: number = 1;
    ciudad: string = '';
    munId: string = '';
    cpId: number = 0;
    clienteId: number = 0;
    direccionClienteId: number = 0;
    direccionClienteIDEnc: string = '';
    aseguradora_cod_col: string = "1"; // Código de colonia para la aseguradora
}

export class ContratanteMoral {
    razon_social: string = '';
    giro: string = '';
    regimen: boolean = true;
    tipoSociedad: number = 1;
}

export class TelefonosContratante {
    cve_lada: string = '81';
    cve_lada_nac: string = '52';
    num_tel: string = '8181818181';
    tipo: number = 1; //1 - Celular, 2 - Teléfono
}

export class CorreosContratante {
    correo:string = '';
    tipo:number = 1;
}

export class Asegurado {
    constructor(
        public check: boolean = false,
        public paqueteID: number = 0,
        public nombre: string = "",
        public apPat: string = "",
        public apMat: string = "",
        public fecNac: string = "",
        public sexo: number = 0,
        public rfc: string = "",
        public edoCivil: number = 0,

    ) { }
}

export class Beneficiario {
    constructor(
        public fiscal: number = 0,
        public parentescoIdEncr: string = "",
        public nombre: string = "",
        public apPat: string = "",
        public apMat: string = "",
        public fecNacimiento: string = "",
        public sexo: number = 0,
        public rfc: string = "",
        public correo: string = "",
        public telefono: string = ""
    ) { }

}